import {
  AUTH_CODE,
  REDIRECT_APP,
  REDIRECT_PATH,
} from '@/constants/authentication';
import { getAuthTokensFromLocalStorage } from '@/utils/auth';
import { performRedirect } from '@/utils/redirect';

export const useRedirect = () => {
  const redirectFromLocalStorage = (additionalParams?: {
    [key: string]: string | null;
  }) => {
    const { authCode } = getAuthTokensFromLocalStorage();

    const params = {
      redirectApp: localStorage.getItem(REDIRECT_APP),
      redirectPath: localStorage.getItem(REDIRECT_PATH),
      authCode: authCode,
      ...additionalParams,
    };

    performRedirect(params);
  };

  return redirectFromLocalStorage;
};
